import { AfterContentInit, AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { IndustrySector } from '../../interfaces/GetAllIndustrySectors.interface';
import { IndustrySectorsAndFeildsService } from 'app/shared/services/industry-sectors-and-feilds.service';

@Component({
  selector: 'app-control-items',
  templateUrl: './control-items.component.html',
  styleUrls: ['./control-items.component.scss']
})

// ------------------------------------------  Eng Ahmed Abdelhameed ALi => creation & Control Feilds in  IndustrySectors ------------------------------------------

export class ControlItemsComponent implements OnInit, AfterViewInit {

  @Input() action: string = "";
  @Input() industrySector: IndustrySector = {} as IndustrySector;
  @Input() fieldItem: any = {};

  addIndustrySectorFeild = this.formBuiler.group({
    nameInEnglish: ["", Validators.required],
    nameInArabic: ["", Validators.required],
    industryCriticalCodesId: null,
    iafCode: null,
    descriptionInArabic_22: null,
    descriptionInEnglish_22: null,
    iafCode_22: ["", Validators.required],
    isOpen: true,
    industrySecretor_Id: [0, Validators.required],
    industryFiledStatus_Id: [1, Validators.required]
  })

  get getAddIndustrySectorFeilds() {
    return this.addIndustrySectorFeild.controls
  }

  constructor(private modalService: NgbModal, private formBuiler: FormBuilder, private IndustrySectorsAndFeilds: IndustrySectorsAndFeildsService, public activeModal: NgbActiveModal, private toastrService: ToastrService) { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.addIndustrySectorFeild.patchValue({
      industrySecretor_Id: this.industrySector.id,
    })
    if (this.action == 'edit-IndustrySectorFeild') {
      this.addIndustrySectorFeild.patchValue({
        nameInEnglish: this.fieldItem.nameInEnglish,
        nameInArabic: this.fieldItem.nameInArabic,
        iafCode_22: this.fieldItem.iafCode_22
      })
    }
  }

  // ---------------------------------------------------- control Industry Sector Feild --------------------------------------------------
  submit() {
    if (this.addIndustrySectorFeild.valid)
      if (this.action == 'add-IndustrySectorFeild')
        this.IndustrySectorsAndFeilds.postIndustrySectorFeild(this.addIndustrySectorFeild.value).subscribe({
          next: (res: any) => {
            this.toastrService.success(res.message)
          }, error: (res: any) => {
            this.toastrService.error(res.message)
          },
          complete: () => { this.activeModal.dismiss(); this.addIndustrySectorFeild.reset(); location.reload() }
        })
      else if (this.action == 'edit-IndustrySectorFeild') {
        let updateFieldValue = this.addIndustrySectorFeild.value;
        updateFieldValue.id = this.fieldItem.id;
        this.IndustrySectorsAndFeilds.updateIndustrySectorFeild(updateFieldValue).subscribe({
          next: (res: any) => {
            this.toastrService.success(res.message)
          }, error: (res: any) => {
            this.toastrService.error(res.message)
          },
          complete: () => { this.activeModal.dismiss(); this.addIndustrySectorFeild.reset(); location.reload() }
        })
      }
  }


}
